import Main from "./Main/main";
import About from "./About/about";
import Projects from "./Projects/projects";
import Contact from "./Contact/contact";

export default function Home() {
    return (
      <>
        <Main />
        <About />
        <Projects />
        <Contact />
      </>
    );
}